import { getUserDetailFromToken } from "services/LocalStorage/LocalStorage.service";
import customAxiosInterceptor from "../customAxiosInterceptor";

// Fetch user
// ovaj ne koristim - GET https://api.infocomp.ba/api/user/{id}
// GET https://api.infocomp.ba/api/user/profile
export const fetchUserThunk = async (thunkAPI) => {
  try {
    // const { id } = getUserDetailFromToken();
    const response = await customAxiosInterceptor.get("/user/profile");
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};
// TODO PREGLEDATI GDE SE OVE METODE KORISTE
// DELETE https://api.infocomp.ba/api/user/{id}
export const deleteUserThunk = async (thunkAPI, { payload }) => {
  try {
    const response = await customAxiosInterceptor.delete("/user/" + payload);
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

// GET https://api.infocomp.ba/api/user/role
export const fetchUserRoleThunk = async (thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get("/user/role");
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

// Fetch user statistic
// * GET /api/statistic
export const fetchUserStatisticThunk = async (thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get("/statistic");
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

// * Ocenjeni artikli
//     * GET /api/article-rate?page=1&take=12
//     * Evo ti api da povuces ocjenjene artikle od strane ulogovanog korisnika,
// napravio sam da je paginirano jer ih moze imati vise
// * Lajkovani proizvodi
//     * GET /api/order?page=1&take=12
//     * Evo ti api da povuces sve narudzbe od strane ulogovanog korisnika,
// napravio sam da je paginirano jer ih moze imati vise
